import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UseMutateAsyncFunction } from 'react-query';
import { usePortfolioReportParamsQuery } from '../../api/usePortfolioReportParamsQuery';
import { MarginProps } from '../../../theme/styledProps';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { routeParamsSelector } from '../../../CommonComponents/Router/Selector';
import { UseGenerateReportMutationParams } from '../../api/useGenerateReportMutation';
import { useSelectedReport } from '../../state';
import { Radio } from '../../../CommonComponents/OPL/Radio/Radio';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Label } from '../../../CommonComponents/OPL/Label/Label';
import { ReportFormatsDTO } from '../../types';

interface Props extends MarginProps {
  isLoading: boolean;
  generateReport: UseMutateAsyncFunction<unknown, Error, UseGenerateReportMutationParams>;
}

export const GenerateReport: React.FC<Props> = ({ isLoading, generateReport, ...rest }) => {
  const [selectedFormat, setSelectFormat] = useState<ReportFormatsDTO>(ReportFormatsDTO.PDF);
  const { clientId } = useSelector(routeParamsSelector);

  const { selectedReport } = useSelectedReport();

  const { data, isError } = usePortfolioReportParamsQuery();

  useEffect(() => {
    setSelectFormat(ReportFormatsDTO.PDF);
  }, [selectedReport]);

  if (isError || !data) {
    return null;
  }

  if (!selectedReport) {
    return null;
  }

  const { allowedReportFormats } = data;

  const handleGenerateReport = async () => {
    const { params } = data;

    try {
      await generateReport({
        clientId,
        reportId: selectedReport.id,
        params: Object.values(params),
        reportFormat: selectedFormat,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Wrapper {...rest}>
      {allowedReportFormats.length > 1 && (
        <>
          <Label htmlFor="adv-download-format" mb="12">
            Download Format
          </Label>
          <Box display="flex" mb="32">
            {allowedReportFormats.map(format => (
              <Radio
                key={format}
                id="adv-download-format"
                checked={format === selectedFormat}
                onChange={() => {
                  setSelectFormat(format);
                }}
              >
                {ReportFormatsDTO[format]}
              </Radio>
            ))}
          </Box>
        </>
      )}

      <Button leftIcon="far fa-bolt" isLoading={isLoading} onClick={handleGenerateReport}>
        Generate
      </Button>
    </Wrapper>
  );
};
